import React from 'react';

/**
 * "Know-how" technique - seems that Next.JS does not allow to use custom layout for `not-found` error page.
 * To apply custom styles to footer (dark theme) we alter `not-found` page component and apply a global
 * css class `ia-dark-theme-enforcing`, then check if child component of Layout has this class. That's a weird solution,
 * but at the moment the only one which allows to properly alter styles for both `404` pages (which can be
 * intercepted using dynamic routes) as well as for `notFound()` error (which cannot be intercepted by dynamic route).
 */
const DarkThemeEnforcer: React.FC = () => (
  <div className="ia-dark-theme-enforcing" />
);

export default DarkThemeEnforcer;
